/* ============================================================================
   SUNNY STRIPES — QUOTE BUILDER BOOST                               v2026-09-18
   ----------------------------------------------------------------------------
   Deep Lawn-style upgrades bolted onto the existing builders WITHOUT editing
   them. Every builder keeps working exactly as before if this file fails.

     1. CONTACT FIRST   Name + email (phone optional) right after the address,
                        before the price shows. Fires a Klaviyo "Quote Started"
                        event so unfinished quotes can be followed up.
     2. COUNTY RECORDS  After the address is picked, the lot outline comes from
                        the Wisconsin statewide parcel layer: lot size plus an
                        estimated lawn, one tap to use it. (Exact tracing stays
                        in each builder's own "Measure from satellite".)
     3. SNOW DRIVEWAY   Trace the driveway (and walks) on satellite; the right
                        driveway card is picked for you.
     4. SNOW ROUTES     Spots-left counter, on-route vs off-route pricing, and a
                        deposit checkout after the request.

   HOLDS NO PRICES. Snow route numbers come from SS_RATES.snowRoutes, which
   snippets/ss-rates.liquid fills in (the deposit product's live inventory is
   the spots-left counter). Driveway tiers come from SS_RATES.snow.drives.

   Loaded by snippets/ss-rates.liquid. It is deferred like the builders and
   waits for DOMContentLoaded, so every builder has already initialised.
   ============================================================================ */
(function () {
  "use strict";

  var RATES = window.SS_RATES;
  var CFG = window.SS_BOOST_CFG || {};
  var KLAVIYO = CFG.klaviyo || "SKBLA9";
  var PARCELS = "https://services3.arcgis.com/n6uYoouQZW75n5WI/arcgis/rest/services/Wisconsin_Statewide_Parcels_DB/FeatureServer/0/query";

  /* Every builder uses the same id scheme: <prefix>addr, <prefix>email ...
     step1 = the first wizard panel (null for the one-screen builders). */
  var TOOLS = [
    { id: "snow",        p: "sn", step1: "sp1", gate: true,  parcel: false, drive: true },
    { id: "topdressing", p: "td", step1: "tp1", gate: true,  parcel: true },
    { id: "aeration",    p: "ao", step1: "ap1", gate: true,  parcel: true },
    { id: "instant",     p: "",   step1: "p1",  gate: true,  parcel: true, email: "email1", root: "sqapp" },
    { id: "fert",        p: "ft", step1: null,  gate: false, parcel: false, root: "fttool" },
    { id: "cleanups",    p: "cl", step1: null,  gate: false, parcel: false, root: "cltool" }
  ];

  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", "\"": "&quot;" }[c]; }); };
  var fmt = function (n) { return Math.round(n).toLocaleString("en-US"); };
  var money = function (n) { return "$" + Math.round(n).toLocaleString("en-US"); };
  function once(k) { try { if (sessionStorage.getItem("ssb1_" + k)) return false; sessionStorage.setItem("ssb1_" + k, "1"); } catch (e) {} return true; }
  function fire(el, type) { if (el) el.dispatchEvent(new Event(type, { bubbles: true })); }
  function visible(el) { return !!(el && el.offsetParent !== null); }
  var emailOk = function (v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || "").trim()); };

  /* ------------------------------------------------------------------ CSS */
  var CSS =
    ".ssb-card{background:#eef4ee;border:2px solid #cfe0cf;border-radius:14px;padding:14px 16px;margin:14px 0}" +
    ".ssb-card h4{margin:0 0 4px;font-size:17px;font-weight:800;color:#183a1e;line-height:1.2}" +
    ".ssb-card p.ssb-sub{margin:0 0 10px;font-size:14px;color:#5f7060;line-height:1.35}" +
    ".ssb-row{display:flex;gap:10px;flex-wrap:wrap}" +
    ".ssb-in{flex:1 1 160px;display:flex;flex-direction:column;gap:4px;font-size:13px;font-weight:700;color:#22331f}" +
    ".ssb-in input{font:inherit;font-weight:500;font-size:16px;padding:11px 12px;border:2px solid #e4e6e1;border-radius:10px;background:#fff;color:#22331f;width:100%;box-sizing:border-box;box-shadow:none}" +
    ".ssb-in input:focus{outline:none;border-color:#4c8a54}" +
    ".ssb-in input.ssb-bad{border-color:#c0392b}" +
    ".ssb-err{display:none;color:#c0392b;font-size:13px;font-weight:700;margin-top:8px}" +
    ".ssb-fine{font-size:12px;color:#5f7060;margin-top:8px}" +
    ".ssb-lock{position:relative}" +
    ".ssb-lock>*:not(.ssb-veil){filter:blur(7px);pointer-events:none;user-select:none}" +
    ".ssb-veil{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:3;pointer-events:none}" +
    ".ssb-veil span{background:#183a1e;color:#fff;font-weight:800;font-size:14px;padding:9px 14px;border-radius:999px;box-shadow:0 4px 14px rgba(0,0,0,.18);text-align:center;max-width:90%}" +
    ".ssb-btn{appearance:none;border:2px solid #235029;background:#fff;color:#235029;font:inherit;font-weight:800;font-size:15px;padding:9px 16px;border-radius:999px;cursor:pointer;line-height:1.1}" +
    ".ssb-btn.ssb-pri{background:#235029;color:#fff}.ssb-btn.ssb-gold{background:#E0A500;border-color:#E0A500;color:#183a1e}" +
    ".ssb-btn[disabled]{opacity:.4;cursor:default}" +
    ".ssb-lot{display:none;margin-top:10px;padding:12px 14px;border-radius:12px;background:#fff;border:2px dashed #E0A500;font-size:14px;line-height:1.45;color:#22331f}" +
    ".ssb-lot b{color:#183a1e}.ssb-lot .ssb-btn{margin-top:8px}" +
    ".ssb-map{height:360px;border-radius:12px;overflow:hidden;border:2px solid #e4e6e1;margin-top:10px;display:none}" +
    ".ssb-tools{display:none;gap:8px;flex-wrap:wrap;margin-top:10px}" +
    ".ssb-chip{appearance:none;border:2px solid #e4e6e1;background:#fff;font:inherit;font-weight:700;font-size:14px;padding:7px 12px;border-radius:999px;cursor:pointer;color:#22331f}" +
    ".ssb-chip.on{border-color:#2F6FE0;background:#e9f0fd}" +
    ".ssb-read{margin-top:8px;font-size:14px;color:#22331f}" +
    ".ssb-route{margin:12px 0;padding:11px 14px;border-radius:12px;font-size:14px;font-weight:700;line-height:1.35}" +
    ".ssb-route.on{background:#eef4ee;color:#183a1e;border:2px solid #4c8a54}" +
    ".ssb-route.off{background:#fff7e0;color:#6b4d00;border:2px solid #E0A500}" +
    ".ssb-spots{display:flex;align-items:center;gap:10px;background:#183a1e;color:#fff;border-radius:12px;padding:10px 14px;margin:0 0 14px;font-size:14px;font-weight:700}" +
    ".ssb-spots b{font-size:22px;color:#E0A500}" +
    ".ssb-dep{margin-top:16px;padding:16px;border-radius:14px;background:#183a1e;color:#fff;text-align:left}" +
    ".ssb-dep h4{margin:0 0 6px;font-size:18px;color:#fff}.ssb-dep p{margin:0 0 12px;font-size:14px;color:#cfe3cf;line-height:1.4}" +
    "@media(max-width:600px){.ssb-map{height:300px}}";

  /* ---------------------------------------------------------- Klaviyo */
  function e164(p) { var d = String(p || "").replace(/\D/g, ""); if (d.length === 10) return "+1" + d; if (d.length === 11 && d.charAt(0) === "1") return "+" + d; return null; }
  function klaviyo(metric, props, who) {
    if (!/^https?:$/.test(location.protocol)) return;
    try {
      var prof = { email: who.email };
      if (who.first_name) prof.first_name = who.first_name;
      var ph = e164(who.phone); if (ph) prof.phone_number = ph;
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(KLAVIYO), {
        method: "POST", headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify({ data: { type: "event", attributes: {
          metric: { data: { type: "metric", attributes: { name: metric } } },
          properties: props, profile: { data: { type: "profile", attributes: prof } } } } })
      })["catch"](function () {});
    } catch (e) {}
  }

  /* ---------------------------------------------- the place they picked
     Every builder resolves the chosen suggestion with Place.fetchFields().
     Wrapping it once hands us the coordinates without touching any builder. */
  var PLACE = null, placeListeners = [];
  function onPlace(fn) { placeListeners.push(fn); if (PLACE) fn(PLACE); }
  function hookPlaces() {
    if (!(window.google && google.maps && google.maps.importLibrary)) return false;
    google.maps.importLibrary("places").then(function (lib) {
      var P = lib && lib.Place; if (!P || P.prototype.__ssb) return;
      var orig = P.prototype.fetchFields;
      P.prototype.fetchFields = function () {
        var self = this;
        return orig.apply(this, arguments).then(function (res) {
          try {
            var pl = (res && res.place) || self;
            if (pl && pl.location) {
              var comps = pl.addressComponents || [];
              var get = function (t) { for (var i = 0; i < comps.length; i++) if ((comps[i].types || []).indexOf(t) >= 0) return comps[i].longText || ""; return ""; };
              PLACE = { lat: pl.location.lat(), lng: pl.location.lng(), route: get("route"), number: get("street_number"),
                        city: get("locality") || get("administrative_area_level_3"), formatted: pl.formattedAddress || "" };
              placeListeners.forEach(function (fn) { try { fn(PLACE); } catch (e) {} });
            }
          } catch (e) {}
          return res;
        });
      };
      P.prototype.__ssb = true;
    })["catch"](function () {});
    return true;
  }

  /* --------------------------------------------------- county records */
  function area(pts) {
    var R = 6378137, lat0 = 0, i, s = 0;
    for (i = 0; i < pts.length; i++) lat0 += pts[i][1];
    lat0 = lat0 / pts.length * Math.PI / 180;
    var xy = pts.map(function (c) { return [R * c[0] * Math.PI / 180 * Math.cos(lat0), R * c[1] * Math.PI / 180]; });
    for (i = 0; i < xy.length; i++) { var a = xy[i], b = xy[(i + 1) % xy.length]; s += a[0] * b[1] - b[0] * a[1]; }
    return Math.abs(s / 2) * 10.7639;
  }
  function parcelAt(lat, lng) {
    var q = new URLSearchParams({ f: "json", geometry: lng + "," + lat, geometryType: "esriGeometryPoint", inSR: "4326",
      spatialRel: "esriSpatialRelIntersects", outFields: "SITEADRESS,PROPCLASS", returnGeometry: "true", outSR: "4326", resultRecordCount: "1" });
    var ctl = window.AbortController ? new AbortController() : null;
    setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
    return fetch(PARCELS + "?" + q, ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
      var f = j && j.features && j.features[0];
      if (!f || !f.geometry || !f.geometry.rings) return null;
      var sq = f.geometry.rings.reduce(function (s, r) { return s + area(r); }, 0);
      return { sqft: sq, address: f.attributes && f.attributes.SITEADRESS };
    })["catch"](function () { return null; });
  }
  /* Lot minus house, drive, walks and beds. On a city lot that is roughly half;
     the (3,000 + 8%) rule matched the Castle Ave and Crestwood checks. */
  function turfFromLot(lot) {
    var t = lot - (3000 + 0.08 * lot);
    return Math.max(Math.round(t / 50) * 50, Math.round(lot * 0.3 / 50) * 50);
  }

  function lotReadout(t) {
    var anchor = $(t.p + "areaMsg") || $(t.p + "addrField");
    if (!anchor) return;
    var box = document.createElement("div");
    box.className = "ssb-lot";
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    onPlace(function (pl) {
      box.style.display = "block";
      box.innerHTML = "Looking up your lot in county records&hellip;";
      parcelAt(pl.lat, pl.lng).then(function (p) {
        if (!p || p.sqft < 1500 || p.sqft > 5 * 43560) { box.style.display = "none"; return; }
        var turf = turfFromLot(p.sqft);
        BOOST.lotSqft = Math.round(p.sqft);
        box.innerHTML = "<b>County records:</b> your lot is " + fmt(p.sqft) + " sq ft (" + (p.sqft / 43560).toFixed(2) +
          " acres). After the house, drive and beds, that is roughly <b>" + fmt(turf) + " sq ft of lawn</b>." +
          "<br><button type=\"button\" class=\"ssb-btn ssb-gold\" data-ssb-use=\"" + turf + "\">Use " + fmt(turf) + " sq ft</button>" +
          " <span class=\"ssb-fine\">or trace it exactly with &ldquo;Measure from satellite&rdquo;.</span>";
      });
    });
    box.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-ssb-use]"); if (!b) return;
      var mode = $(t.p + "segSqft") || $(t.p + "modeSqft");
      if (mode) mode.click();
      var inp = $(t.p + "sqft");
      if (inp) { inp.value = b.getAttribute("data-ssb-use"); fire(inp, "input"); fire(inp, "change"); }
      b.textContent = "Using " + fmt(+b.getAttribute("data-ssb-use")) + " sq ft ✓"; b.disabled = true;
    });
  }

  /* ---------------------------------------------------- contact first */
  function field(t, k) { return $(t.p + k) || null; }
  function contactCard(t) {
    var zip = field(t, "zip"), anchor = $(t.p + "areaMsg") || (zip && zip.closest("div"));
    if (!anchor) return null;
    var card = document.createElement("div");
    card.className = "ssb-card"; card.id = "ssb-who-" + t.id;
    card.innerHTML =
      "<h4>Where should we send your price?</h4>" +
      "<p class=\"ssb-sub\">We&rsquo;ll email you a copy so you don&rsquo;t lose it. No spam, no sales calls you didn&rsquo;t ask for.</p>" +
      "<div class=\"ssb-row\">" +
      "<label class=\"ssb-in\">First name<input type=\"text\" autocomplete=\"given-name\" data-k=\"fname\"></label>" +
      "<label class=\"ssb-in\">Email<input type=\"email\" autocomplete=\"email\" inputmode=\"email\" data-k=\"email\"></label>" +
      "<label class=\"ssb-in\">Mobile <span style=\"font-weight:500;color:#5f7060\">(optional, for a text copy)</span><input type=\"tel\" autocomplete=\"tel\" inputmode=\"tel\" data-k=\"phone\"></label>" +
      "</div><div class=\"ssb-err\">Add your first name and a working email to see your price.</div>";
    anchor.parentNode.insertBefore(card, anchor.nextSibling);
    var inputs = {};
    [].forEach.call(card.querySelectorAll("input"), function (i) {
      inputs[i.getAttribute("data-k")] = i;
      i.value = "";   /* always start blank - never prefill from a past visit */
    });
    return { card: card, inputs: inputs };
  }

  function who(c) { return { first_name: c.inputs.fname.value.trim(), email: c.inputs.email.value.trim(), phone: c.inputs.phone.value.trim() }; }
  function whoOk(c) { var w = who(c); return !!w.first_name && emailOk(w.email); }

  function mirror(t, c) {
    var w = who(c);
    [["fname", w.first_name], ["email", w.email], ["phone", w.phone]].forEach(function (pair) {
      var own = field(t, pair[0]);
      if (own && pair[1] && own.value !== pair[1]) { own.value = pair[1]; fire(own, "input"); }
    });
    if (t.email) { var e1 = $(t.email); if (e1 && w.email && e1.value !== w.email) { e1.value = w.email; fire(e1, "input"); fire(e1, "change"); } }
  }

  function priceTargets(t) {
    var head = $(t.p ? t.p + "EstHead" : "estHead"), out = [];
    if (head) out.push(head.closest(".side") || head.parentNode);
    var m = $(t.p ? t.p + "mAmt" : "mAmt"); if (m) out.push(m);
    return out.filter(Boolean);
  }
  function lock(t, on) {
    priceTargets(t).forEach(function (el) {
      var v = el.querySelector(":scope > .ssb-veil");
      if (on) {
        el.classList.add("ssb-lock");
        if (!v) { v = document.createElement("div"); v.className = "ssb-veil"; v.innerHTML = "<span>Add your name &amp; email to see your price</span>"; el.appendChild(v); }
        if (el.id && /mAmt$/.test(el.id)) v.innerHTML = "<span>Add your email</span>";
      } else {
        el.classList.remove("ssb-lock"); if (v) v.parentNode.removeChild(v);
      }
    });
  }

  function started(t, c) {
    if (!once("started_" + t.id)) return;
    var w = who(c), addr = field(t, "addr"), city = field(t, "city"), zip = field(t, "zip");
    klaviyo("Quote Started", {
      tool: t.id, page: location.pathname,
      address: addr ? addr.value.trim() : "", city: city ? city.value : "", zip: zip ? zip.value.trim() : "",
      lot_sqft: BOOST.lotSqft || null, on_snow_route: BOOST.onRoute
    }, w);
  }

  function gate(t) {
    var c = contactCard(t);
    if (!c) return;
    var step1 = $(t.step1);
    var sync = function () {
      var ok = whoOk(c);
      mirror(t, c);
      lock(t, !ok && visible(step1));
      if (ok) c.card.querySelector(".ssb-err").style.display = "none";
    };
    [].forEach.call(c.card.querySelectorAll("input"), function (i) {
      i.addEventListener("input", function () { i.classList.remove("ssb-bad"); sync(); });
      /* Log the start as soon as we have a real contact, not only when they
         press Next: the people who stop here are the ones worth following up. */
      i.addEventListener("change", function () { if (whoOk(c)) started(t, c); });
    });
    sync();
    /* Stop the wizard leaving step 1 until we know who to send the price to.
       Capture phase on document runs before every builder's own handler,
       inline onclick="go(2)" included. */
    document.addEventListener("click", function (ev) {
      var tg = ev.target; if (!tg || !tg.closest || !visible(step1)) return;
      var adv = tg.closest(
        "#" + t.step1 + " [data-go='2'], #" + t.step1 + " [data-go='3'], #" + t.step1 + " [onclick*='go(2)'], " +
        "#" + (t.p ? t.p + "mBtn" : "mbar button") + ", #" + (t.p ? t.p + "steps" : "steps") + " .st");
      if (!adv) return;
      if (tg.closest("#" + (t.p ? t.p + "steps" : "steps")) && adv.getAttribute("data-s") === "1") return;
      if (!whoOk(c)) {
        ev.preventDefault(); ev.stopImmediatePropagation();
        c.card.querySelector(".ssb-err").style.display = "block";
        var w = who(c);
        if (!w.first_name) { c.inputs.fname.classList.add("ssb-bad"); c.inputs.fname.focus(); }
        else { c.inputs.email.classList.add("ssb-bad"); c.inputs.email.focus(); }
        c.card.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      mirror(t, c); started(t, c); lock(t, false);
    }, true);
    /* The builders re-render the rail on every change; keep the veil on top. */
    var tries = 0, keep = setInterval(function () { if (++tries > 600) return clearInterval(keep); sync(); }, 1500);
  }

  /* One-screen builders (fert, cleanups): no gate, just log the start once
     they type a real email into their own form. */
  function softStart(t) {
    var em = field(t, "email"); if (!em) return;
    em.addEventListener("change", function () {
      if (!emailOk(em.value)) return;
      var fn = field(t, "fname"), ph = field(t, "phone");
      started(t, { inputs: { fname: { value: fn ? fn.value : "" }, email: { value: em.value }, phone: { value: ph ? ph.value : "" } } });
    });
  }

  /* ============================================================= SNOW */
  var BOOST = { lotSqft: null, onRoute: null };
  var ROUTES = (RATES && RATES.snowRoutes) || window.SS_SNOW_ROUTES || null;

  function streetKey(s) {
    return String(s || "").toLowerCase().replace(/[.,]/g, " ")
      .replace(/\b(north|south|east|west|n|s|e|w)\b/g, " ")
      .replace(/\b(street|st|avenue|ave|road|rd|drive|dr|lane|ln|court|ct|place|pl|boulevard|blvd|circle|cir|way|trail|trl|parkway|pkwy|terrace|ter|highway|hwy|county road|cty rd|co rd)\b/g, " ")
      .replace(/\s+/g, " ").trim();
  }
  function onRouteStreet(route) {
    if (!ROUTES || !ROUTES.onRouteStreets || !ROUTES.onRouteStreets.length || !route) return null;
    var k = streetKey(route);
    return ROUTES.onRouteStreets.some(function (s) { return streetKey(s) === k; });
  }

  /* Off-route surcharge, applied inside the shared snow maths so the rail, the
     comparison, the lead email and Klaviyo all see the same number. */
  function wrapSnowRates() {
    if (!RATES || RATES.__ssbSnow || !ROUTES || !(ROUTES.offRoutePct > 0)) return;
    var pct = ROUTES.offRoutePct;
    var r5 = function (n) { return Math.round(n / 5) * 5; };
    var up = function () { return BOOST.onRoute === false; };
    var pp = RATES.snowPerPush, ss = RATES.snowSeason, dr = RATES.snowDepthRows;
    if (pp) RATES.snowPerPush = function () { var v = pp.apply(RATES, arguments); return (up() && v != null) ? r5(v * (1 + pct)) : v; };
    if (ss) RATES.snowSeason = function () { var v = ss.apply(RATES, arguments); return (up() && v != null) ? r5(v * (1 + pct)) : v; };
    if (dr) RATES.snowDepthRows = function () {
      var rows = dr.apply(RATES, arguments);
      if (!up() || !rows) return rows;
      return rows.map(function (r) { var o = {}; for (var k in r) o[k] = r[k]; if (o.price != null) o.price = r5(o.price * (1 + pct)); return o; });
    };
    RATES.__ssbSnow = true;
  }
  function rerenderSnow() { var sel = document.querySelector("#sndrives .lot.sel") || document.querySelector("#sndrives .lot"); if (sel) sel.click(); }

  function snowRouteUI() {
    var step1 = $("sp1"); if (!step1 || !ROUTES) return;
    if (ROUTES.spotsLeft != null) {
      var sp = document.createElement("div");
      sp.className = "ssb-spots";
      sp.innerHTML = ROUTES.spotsLeft > 0
        ? "<b>" + ROUTES.spotsLeft + "</b><span>driveway" + (ROUTES.spotsLeft === 1 ? "" : "s") + " left on our routes this winter. When a route is full, it&rsquo;s full until spring.</span>"
        : "<span>Our residential routes are full for this winter. Send a request anyway and we&rsquo;ll call if a spot opens up.</span>";
      step1.insertBefore(sp, step1.firstChild);
    }
    var badge = document.createElement("div");
    badge.className = "ssb-route"; badge.style.display = "none";
    var anchor = $("snareaMsg"); if (anchor) anchor.parentNode.insertBefore(badge, anchor.nextSibling);
    onPlace(function (pl) {
      var on = onRouteStreet(pl.route);
      BOOST.onRoute = on;
      if (on === null) { badge.style.display = "none"; rerenderSnow(); return; }
      badge.style.display = "block";
      if (on) { badge.className = "ssb-route on"; badge.innerHTML = "✓ We already plow on " + esc(pl.route) + ". You&rsquo;re first in line for a spot."; }
      else {
        badge.className = "ssb-route off";
        badge.innerHTML = esc(pl.route || "That street") + " isn&rsquo;t on one of our routes yet, so prices below include " +
          Math.round(ROUTES.offRoutePct * 100) + "% for the extra drive.";
      }
      rerenderSnow();
    });
    /* Tag the lead email so Carl knows why an off-route number is higher. */
    document.addEventListener("click", function (ev) {
      if (!ev.target || ev.target.id !== "snsubmit") return;
      var n = $("snnotes"); if (!n || BOOST.onRoute === null) return;
      var tag = BOOST.onRoute ? "[Route: ON an existing route]" : "[Route: OFF-route, +" + Math.round(ROUTES.offRoutePct * 100) + "% applied]";
      if (n.value.indexOf("[Route:") < 0) n.value = (n.value ? n.value + "\n" : "") + tag;
    }, true);
  }

  function snowDeposit() {
    var done = $("spDone"); if (!done || !ROUTES || !ROUTES.depositVariant) return;
    var shown = false;
    var check = function () {
      if (shown || done.style.display === "none" || !visible(done)) return;
      var ptCom = $("snptCom");
      if (ptCom && ptCom.classList.contains("on")) return;        /* commercial: site walk, no deposit */
      var head = $("snEstHead");
      if (head && /custom/i.test(head.textContent)) return;       /* extra-long: we measure first */
      shown = true;
      var ref = (($("sndoneRef") || {}).textContent || "").replace(/^Reference\s*/i, "").trim();
      var box = document.createElement("div");
      box.className = "ssb-dep";
      if (ROUTES.spotsLeft === 0) {
        box.innerHTML = "<h4>You&rsquo;re on the waitlist</h4><p>Our routes are full for this winter. We&rsquo;ll call you first if a spot opens up.</p>";
      } else {
        var url = "/cart/" + ROUTES.depositVariant + ":1?attributes%5BSnow%20reference%5D=" + encodeURIComponent(ref || "snow quote");
        box.innerHTML = "<h4>Lock in your spot on our route</h4>" +
          "<p>A " + money(ROUTES.deposit) + " deposit holds your driveway for the winter and comes off your first snow invoice." +
          (ROUTES.spotsLeft != null ? " " + ROUTES.spotsLeft + " spot" + (ROUTES.spotsLeft === 1 ? "" : "s") + " left." : "") + "</p>" +
          "<a class=\"ssb-btn ssb-gold\" href=\"" + url + "\" style=\"display:inline-block;text-decoration:none\">Reserve my spot &mdash; " + money(ROUTES.deposit) + " &rarr;</a>" +
          "<p class=\"ssb-fine\" style=\"color:#9fbf9f;margin:10px 0 0\">Rather wait? No problem &mdash; we&rsquo;ll reach out about your request either way.</p>";
      }
      done.appendChild(box);
      klaviyo("Snow Deposit Offered", { reference: ref, on_snow_route: BOOST.onRoute, spots_left: ROUTES.spotsLeft },
              { email: (($("snemail") || {}).value || "").trim(), first_name: (($("snfname") || {}).value || "").trim(), phone: (($("snphone") || {}).value || "") });
    };
    setInterval(check, 800);
  }

  /* Driveway tracing. SS_MEASURE (assets/ss-measure.js) already does the
     drawing for the commercial intake; this reuses it for homeowners. */
  function driveTiers() {
    var ds = (RATES && RATES.snow && RATES.snow.drives) || [];
    return ds.map(function (d) {
      var nums = String(d.sz || "").match(/[\d,]+/g) || [];
      var last = nums.length ? parseInt(nums[nums.length - 1].replace(/,/g, ""), 10) : Infinity;
      return { k: d.k, nm: d.nm, max: (d.custom || /\+/.test(d.sz)) ? Infinity : last };
    });
  }
  function driveFor(sqft) { var t = driveTiers(); for (var i = 0; i < t.length; i++) if (sqft <= t[i].max) return t[i]; return t[t.length - 1]; }

  function snowMeasure() {
    var block = $("sndriveBlock"), cards = $("sndrives");
    if (!block || !cards) return;
    var wrap = document.createElement("div");
    wrap.className = "ssb-card"; wrap.style.background = "#fff";
    wrap.innerHTML =
      "<h4>Not sure which size? Trace it.</h4>" +
      "<p class=\"ssb-sub\">Pick your address above, then tap the corners of your driveway on the satellite map. We&rsquo;ll choose the right size for you.</p>" +
      "<button type=\"button\" class=\"ssb-btn ssb-pri\" data-ssb=\"open\">Measure my driveway</button>" +
      "<div class=\"ssb-map\"></div>" +
      "<div class=\"ssb-tools\">" +
      "<button type=\"button\" class=\"ssb-chip on\" data-surf=\"drive\">Driveway</button>" +
      "<button type=\"button\" class=\"ssb-chip\" data-surf=\"walk\">Walks (tap along the middle)</button>" +
      "<button type=\"button\" class=\"ssb-btn ssb-pri\" data-ssb=\"finish\" disabled>Finish shape</button>" +
      "<button type=\"button\" class=\"ssb-btn\" data-ssb=\"undo\">Undo</button>" +
      "<button type=\"button\" class=\"ssb-btn\" data-ssb=\"clear\">Start over</button></div>" +
      "<div class=\"ssb-read\"></div>";
    block.insertBefore(wrap, cards);
    var mapEl = wrap.querySelector(".ssb-map"), tools = wrap.querySelector(".ssb-tools"), read = wrap.querySelector(".ssb-read");
    var M = null;
    var surfaces = [
      { key: "drive", label: "Driveway", mode: "area", color: "#2F6FE0" },
      { key: "walk", label: "Walks", mode: "path", color: "#46B4FF", width: 4 }
    ];
    function paint(api) {
      if (!api || api.stuck) return;
      var t = api.totals(), cur = api.currentSurface();
      [].forEach.call(tools.querySelectorAll("[data-surf]"), function (b) { b.classList.toggle("on", b.getAttribute("data-surf") === cur); });
      var need = cur === "drive" ? 3 : 2;
      tools.querySelector("[data-ssb='finish']").disabled = !(api.drafting() && api.draftPoints() >= need);
      var d = t.drive ? t.drive.sqft : 0, w = t.walk ? t.walk.feet : 0;
      if (!d && !api.drafting()) { read.innerHTML = "Tap each corner of the driveway, including the apron to the street, then <b>Finish shape</b>."; return; }
      if (!d) { read.innerHTML = "<b>" + api.draftPoints() + "</b> point" + (api.draftPoints() === 1 ? "" : "s") + " &mdash; keep tapping corners, then Finish shape."; return; }
      var tier = driveFor(d);
      read.innerHTML = "Driveway: <b>" + fmt(d) + " sq ft</b> &rarr; priced as <b>" + esc(tier.nm) + "</b>" +
        (w ? " &middot; Walks: " + fmt(w) + " ft" : "");
      var card = document.querySelector("#sndrives .lot[data-d='" + tier.k + "']");
      if (card && !card.classList.contains("sel")) card.click();
      var wk = $("snsvcWalks");
      if (w && wk && !wk.classList.contains("on")) wk.click();
    }
    function open() {
      var loc = PLACE ? { lat: PLACE.lat, lng: PLACE.lng } : null;
      if (!loc) { read.innerHTML = "<span style=\"color:#c0392b;font-weight:700\">Pick your address from the suggestions above first, so the map knows where to look.</span>"; return; }
      mapEl.style.display = "block"; tools.style.display = "flex";
      wrap.querySelector("[data-ssb='open']").style.display = "none";
      ensureMeasure(function () {
        if (M) { M.invalidate(loc, 20); return; }
        M = window.SS_MEASURE.create({ mapEl: mapEl, center: loc, zoom: 20, surfaces: surfaces, onChange: paint,
          onStuck: function () { tools.style.display = "none"; read.innerHTML = "The map isn&rsquo;t loading right now &mdash; just pick the closest size below."; } });
        if (M.notReady) { M = null; read.innerHTML = "The map isn&rsquo;t available right now &mdash; pick the closest size below."; }
      });
    }
    wrap.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("button"); if (!b) return;
      var a = b.getAttribute("data-ssb"), s = b.getAttribute("data-surf");
      if (a === "open") return open();
      if (!M) return;
      if (s) M.setSurface(s);
      if (a === "finish") M.finish();
      if (a === "undo") M.undo();
      if (a === "clear") M.clear();
    });
    onPlace(function (pl) { if (M) M.recenter({ lat: pl.lat, lng: pl.lng }, 20); });
  }

  function ensureMeasure(cb) {
    var go = function () {
      if (!(window.google && google.maps)) return;
      var ready = function () { if (window.SS_MEASURE) cb(); };
      (google.maps.geometry ? Promise.resolve() : google.maps.importLibrary("geometry")).then(function () {
        if (window.SS_MEASURE) return ready();
        if (!CFG.measureSrc) return;
        var sc = document.createElement("script"); sc.src = CFG.measureSrc; sc.onload = ready; document.head.appendChild(sc);
      })["catch"](function () {});
    };
    go();
  }

  /* ============================================================= boot */
  function boot() {
    try { localStorage.removeItem("ssb_who"); } catch (e) {}   /* clear anything an earlier version saved */
    var st = document.createElement("style"); st.id = "ssb-css"; st.textContent = CSS; document.head.appendChild(st);
    var any = false;
    TOOLS.forEach(function (t) {
      var root = t.root ? $(t.root) : $(t.p + "addr");
      if (!root) return;
      if (t.id === "instant" && !$("sqapp")) return;
      any = true;
      try {
        if (t.gate) gate(t); else softStart(t);
        if (t.parcel) lotReadout(t);
        if (t.drive) { wrapSnowRates(); snowRouteUI(); snowMeasure(); snowDeposit(); }
      } catch (e) { if (window.console) console.error("ss-boost (" + t.id + "):", e); }
    });
    if (!any) return;
    onPlace(function () {});
    var n = 0, iv = setInterval(function () { if (hookPlaces() || ++n > 40) clearInterval(iv); }, 500);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  window.SS_BOOST = { version: "2026-09-18", place: function () { return PLACE; }, state: BOOST, _turf: turfFromLot, _driveFor: driveFor, _streetKey: streetKey };
})();